import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["onClick", "value", "children", "size"];
import { IconButton } from '@mui/material';
export default function FormIconButton(props) {
    var onClick = props.onClick, value = props.value, children = props.children, _a = props.size, size = _a === void 0 ? 'small' : _a, others = _objectWithoutProperties(props, _excluded);
    return /*#__PURE__*/ React.createElement(IconButton, _extends({
        onClick: onClick,
        type: "button",
        size: size
    }, others), children);
}
